import { LabelColor } from "src/components/Label";
import { StationEvseStatus, StationStatus, StationType } from "../types/Station";

// "pending" | "available" | "unavailable"| "reboot-required"| "offline" | "error"
export const getStationStatusColor = (status: StationStatus): LabelColor => {
    switch (status) {
        case "pending":
            return "neutral";
        case "available":
            return "success";
        case "unavailable":
            return "error";
        case "reboot-required":
            return "warning";
        case "offline":
            return "error";
        case "error":
            return "primary";
        default:
            return "neutral";
    }
};
// | "pending" | "available" | "preparing" | "charging" | "suspended" | "finishing" | "reserved" | "unavailable" | "error"
export const getStationEvseStatusColor = (status: StationEvseStatus): LabelColor => {
    switch (status) {
        case "pending":
            return "neutral";
        case "available":
            return "success";
        case "preparing":
            return "info";
        case "charging":
            return "info";
        case "suspended":
            return "info";
        case "finishing":
            return "info";
        case "reserved":
            return "warning";
        case "unavailable":
            return "error";
        case "error":
            return "primary";
        default:
            return "neutral";
    }
};
// "pending" | "available" | "unavailable"| "reboot-required"| "offline" | "error"
export const getStationTypeColor = (status: StationType): LabelColor => {
    switch (status) {
        case StationType.Public:
            return "info";
        case StationType.Private:
            return "warning";
        case StationType.Home:
            return "success";
    }
};
